export default "/images/Claire-EmmanuelleLegault.jpg?e0c407394ecda57e6716e1a70a124b40";